<template>
  <div>
    <div class="flex items-center justify-between pl-10 mb-4">
      <div class="flex items-center">
        <div>
          <span class="text-deep-dark text-lg font-semibold">
            {{ $t('frontend_groovemail_email_builder_route_page_title') }}
          </span>
        </div>
      </div>
      <div class="flex justify-evenly">
        <div
          v-if="showResetTemplate"
          class="cursor-pointer mr-1"
          @click="changeTemplate()"
          v-tooltip="{
            content: `<p class='w-16 text-center font-semibold break-words'>${$t(
              'frontend_groovemail_befree_email_builder_change_template_action_btn_label'
            )}</p>`,
            placement: 'bottom',
            classes: ['info'],
            targetClasses: ['it-has-a-tooltip'],
            offset: 10,
            delay: {
              show: 200,
              hide: 300,
            },
          }"
        >
          <gd-button
            variant="outline"
            size="icon"
          >
           <TemplateIcon class="h-5 w-5"/>
          </gd-button>
        </div>
        <div
          class="cursor-pointer"
          id="updatebutton"
          :class="{
            'mr-3': !(this.openedFrom === 'global' || this.openedFrom === 'my-template'),
            'mr-8': this.openedFrom === 'global' || this.openedFrom === 'my-template',
          }"
          @click="saveBuilderContent(4)"
          v-if=" openedType === 'edit' && (this.openedFrom === 'global' || this.openedFrom === 'my-template')"
          v-tooltip="{
            content: `<p class='w-16 text-center font-semibold break-words'>${$t(
                      'frontend_groovemail_befree_email_builder_templates_page_update_template')
                    }</p>`,
            placement: 'bottom',
            classes: ['info'],
            targetClasses: ['it-has-a-tooltip'],
            offset: 10,
            delay: {
              show: 200,
              hide: 300,
            },
          }"
        >
          <gd-button
            variant="outline"
            size="icon"
          >
           <TemplateUpdateIcon class="h-5 w-5"/>
          </gd-button>
        </div>
        <div
          v-if="!(this.openedFrom === 'global' || this.openedFrom === 'my-template')"
          class="cursor-pointer mr-1"
          @click="saveBuilderContent(1)"
          v-tooltip="{
            content: `<p class='w-16 text-center font-semibold break-words'>${
              this.openedType === 'add'
                ? $t('frontend_groovemail_email_builder_past_template_save_email')
                : $t('frontend_update')
            }</p>`,
            placement: 'bottom',
            classes: ['info'],
            targetClasses: ['it-has-a-tooltip'],
            offset: 10,
            delay: {
              show: 200,
              hide: 300,
            },
          }"
        >
          <gd-button
            variant="outline"
            size="icon"
          >
           <TemplateUpdateIcon class="h-5 w-5"/>
          </gd-button>
        </div>
        <div
          class="cursor-pointer"
          :class="{
            'mr-3': !(this.openedFrom === 'global' || this.openedFrom === 'my-template'),
            'mr-8': this.openedFrom === 'global' || this.openedFrom === 'my-template',
          }"
          @click="saveBuilderContent(2)"
          v-tooltip="{
            content: `<p class='w-16 text-center font-semibold break-words'>${
              this.openedFrom === 'global' || this.openedFrom === 'my-template'
                ? this.openedType === 'add'
                  ? $t('frontend_groovemail_befree_email_builder_templates_page_save_template')
                  : $t('frontend_groovemail_befree_email_builder_templates_page_save_template')
                : $t('frontend_groovemail_befree_email_builder_save_as_templates_label')
            }</p>`,
            placement: 'bottom',
            classes: ['info'],
            targetClasses: ['it-has-a-tooltip'],
            offset: 10,
            delay: {
              show: 200,
              hide: 300,
            },
          }"
        >
          <gd-button
            variant="outline"
            size="icon"
          >
           <TemplateAddIcon class="h-5 w-5"/>
          </gd-button>
        </div>
        <div
          v-if="!(this.openedFrom === 'global' || this.openedFrom === 'my-template')"
          class="cursor-pointer mr-2"
          @click="saveBuilderContent(3)"
          v-tooltip="{
            content: `<p class='w-16 text-center font-semibold break-words'>${
              this.openedType === 'add'
                ? $t('frontend_groovemail_befree_email_builder_save_and_exit_action')
                : $t('frontend_groovemail_befree_email_builder_update_and_exit_action')
            }</p>`,
            placement: 'bottom',
            classes: ['info'],
            targetClasses: ['it-has-a-tooltip'],
            offset: 10,
            delay: {
              show: 200,
              hide: 300,
            },
          }"
        >
          <gd-button
            variant="outline"
            size="icon"
          >
           <ExitLeftIcon class="h-5 w-5" />
          </gd-button>
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <gd-banner
        class="fixed"
        v-if="!canUsePremiumBuilder && showLimitBanner"
        :bannerMsg="bannerConfig.message"
        :bannerTextColor="bannerConfig.textColor"
        :bannerSize="bannerConfig.size"
        :bannerColor="bannerConfig.color"
        :bannerActions="bannerConfig.bannerActions"
      >
        <template slot="action-butons">
          <div class="mr-4">
            <gd-button
              :variant="bannerConfig.actionItems.actionBtnType === 'primary' ? 'primary' : 'dark'"
              size="auto"
              @click="goToUpgradePage"
              >{{ $t(bannerConfig.actionItems.actionBtnText) }}</gd-button
            >
          </div>
          <div class="cursor-pointer" @click="updateLimitBanner(false)">
            <span
              class="fas fa-times text-lg"
              :class="[bannerConfig.textColor]"
            ></span>
          </div>
        </template>
      </gd-banner>
    </div>

    <div class="flex w-full relative" v-if="blockedDomainsFetched">
      <div
        ref="email-builder-html-content"
        class="absolute z-negate gm-beefree-preview-content"
      >
        <div v-html="htmlData"></div>
      </div>
      <email-builder
        class="w-full px-6"
        ref="email-builder"
        :allowSaveRows="allowSaveRows"
        :templateType="templateType"
        :templateId="emailTemplateId"
        :builderVariables="builderVariables"
        @onSaveEmail="savedAsEmail"
        @noContentFound="showErrorMessage('frontend_groovemail_modal_email_template_add_content_before_proceeding')"
        @changeInContent="contentChanged = true"
        @prepareAffiliateLink="openAffiliateLinkModal"
        @prepareSavingRows="openSaveRowMetaModal"
        @onSaveRow="onSaveRow"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
      ></email-builder>
    </div>

    <gd-modal
      id="template-meta-data-modal"
      name="template-meta-data-modal"
      :allowOverflow="false"
      :title="
        this.openedFrom === 'global' ||
        this.openedFrom === 'my-template' ||
        this.saveAs === 2
          ? $t('frontend_groovemail_modal_email_template_data_of_template_header')
          : $t('frontend_groovemail_email_builder_past_template_save_email')
      "
    >
      <div class="w-full p-6" style="max-height: calc(100vh - 115px)">
        <template-meta-data
          ref="templateMetaData"
          :templateMeta="emailTemplateMeta"
          :from="openedFrom"
          :saveAs="saveAs"
          @showLoader="showLoader"
          @hideLoader="hideLoader"
          @saveTemplateWithMeta="saveContentWithMeta"
          @closeTemplateMetaModal="closeTemplateMetaModal"
          @updatedTemplateMeta="updatedTemplateMeta"
          @openCreateFolderModal="openFolderModal"
        />
      </div>
    </gd-modal>

    <gd-modal
      id="template-folder-create-modal"
      name="template-folder-create-modal"
      :title="$t('frontend_new_category')"
      @closed="resetFolderValue"
    >
      <VuePerfectScrollbar>
        <div class="w-full p-6" style="max-height: calc(100vh - 115px)">
          <template-folder-create
            :from="openedFrom"
            @showLoader="showLoader"
            @hideLoader="hideLoader"
            @folderCreatedForTemplates="closeCreateFolderModal"
            @closeFolderCreateModal="closeCreateFolderModal"
          >
          </template-folder-create>
        </div>
      </VuePerfectScrollbar>
    </gd-modal>

    <gd-modal
      id="affiliate-link-create-modal"
      name="affiliate-link-create-modal"
      :title="$t('frontend_groovemail_befree_email_builder_merge_tags_affiliate_link_label')"
      @closed="closedAffiliateLinkModal"
    >
      <div class="p-6">
        <div
          class="flex flex-col"
          :class="{
            'mb-2': isAffiliateSubmitted && !affiliatePromo,
            'mb-6': !(isAffiliateSubmitted && !affiliatePromo),
          }"
        >
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_groovemail_befree_email_builder_merge_tags_promo_label') }}
          </label>
          <treeselect
            class="
              text-sm text-dark
              rounded-lg
              w-full
              custom-treeselect
            "
            :class="{
              'error text-danger': isAffiliateSubmitted && !affiliatePromo
            }"
            v-model="affiliatePromo"
            :multiple="false"
            :options="promoList"
            :max-height="150"
            :clearOnSelect="true"
            :closeOnSelect="true"
            :clearable="false"
            @select="updatedAffiliatePromo($event)"
            :placeholder="$t('frontend_groovemail_befree_email_builder_merge_tags_select_promo_label')"
          />
          <div
            class="text-sm text-danger"
            v-if="isAffiliateSubmitted && !affiliatePromo"
          >
            {{ $t('frontend_groovemail_befree_email_builder_merge_tags_please_select_promo') }}
          </div>
        </div>
        <div
          class="flex flex-col"
          :class="{
            'mb-2': isAffiliateSubmitted && !affiliateLink,
            'mb-6': !(isAffiliateSubmitted && !affiliateLink),
          }"
        >
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_groovemail_befree_email_builder_merge_tags_affiliate_link_label') }}
          </label>
          <treeselect
            class="
              text-sm text-dark
              rounded-lg
              w-full
              custom-treeselect
            "
            v-model="affiliateLink"
            :multiple="false"
            :options="affiliateLinkList"
            :max-height="150"
            :openDirection="'above'"
            :clearOnSelect="true"
            :closeOnSelect="true"
            :clearable="false"
            :placeholder="$t('frontend_groovemail_befree_email_builder_merge_tags_select_affiliate_link_label')"
          />
          <div
            class="text-sm text-danger"
            v-if="isAffiliateSubmitted && !affiliateLink"
          >
            {{ $t('frontend_groovemail_befree_email_builder_merge_tags_please_select_affiliate_link') }}
          </div>
        </div>
      </div>
      <div class="flex justify-end p-6 pt-0">
        <gd-button
          size="auto"
          @click="closeAffiliateLinkModal"
          >{{ $t('frontend_cancel') }}</gd-button
        >
        <gd-button
          variant="primary"
          size="auto"
          @click="createNewAffiliateLink"
          class="ml-2"
          >{{ $t('frontend_save') }}</gd-button
        >
      </div>
    </gd-modal>

    <gd-modal
      id="row-meta-modal"
      name="row-meta-modal"
      :title="
        rowData.id
          ? $t('frontend_groovemail_befree_email_builder_new_row_edit_label')
          : $t('frontend_groovemail_befree_email_builder_new_row_create_label')
      "
      @closed="closedRowModal"
    >
      <div class="p-6">
        <div
          class="flex flex-col"
          :class="{
            'mb-2': isRowSaveSubmitted && !rowName,
            'mb-6': !(isRowSaveSubmitted && !rowName),
          }"
        >
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_groovemail_befree_email_builder_new_row_create_row_name_label') }}
          </label>
          <text-input
            class="inline-block mr-2"
            variant="base"
            v-model="rowName"
            :validator="$v.rowName"
            :placeholder="$t('frontend_groovemail_befree_email_builder_new_row_create_enter_row_name_placeholder')"
          />
        </div>
      </div>
      <div class="flex justify-end p-6 pt-0">
        <gd-button
          size="auto"
          @click="closeRowModal"
          >{{ $t('frontend_cancel') }}</gd-button
        >
        <gd-button
          variant="primary"
          size="auto"
          @click="createNewRow"
          class="ml-2"
          >{{ $t('frontend_save') }}</gd-button
        >
      </div>
    </gd-modal>

    <!-- Popup for free user after limit exceed Start -->
    <gd-modal
      ref="upgradeModal"
      name="upgrade-modal-for-limit-builder"
      :title="$t('frontend_groovemail_upgrade_modal_heading')"
    >
      <upgrade-content
        @closeUpgradeModal="closeUpgradeModalForFreeUsers"
      ></upgrade-content>
    </gd-modal>
  </div>
</template>

<script>
import axios from 'axios';
import EmailBuilder from '@groovepages/gd-ui-kit/components/EmailBuilder';
import GDBanner from '@groovepages/gd-ui-kit/components/GDBanner';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import auth from '@groovepages/gd-lib/auth';
import TemplateMetaData from './template-meta-data.vue';
import TemplateFolderCreate from './template-folder-create.vue';
import UpgradeContent from '@/components/UpgradeContent.vue';
import showAlert from '@/components/sweet-alert-popup.js';
import imageUtils from '@/components/imageUtils';
import themeConfig from '@/theme/themeConfig';

// import icons
import TemplateIcon from '@/assets/images/icons/new/email_tmp_new.svg';
import TemplateAddIcon from '@/assets/images/icons/new/email_tmp_add_new.svg';
import TemplateUpdateIcon from '@/assets/images/icons/new/email_tmp_update_new.svg';
import ExitLeftIcon from '@/assets/images/icons/new/exit_arrow_left_new.svg';

export default {
  middleware: 'auth',
  name: 'builder',

  props: {
    emailTemplateId: {
      required: true,
    },
    templateId: {
      required: false,
      default: null,
    },
    blockedLinkRestriction: {
      required: false,
    },
    builderVariables: {
      required: true,
    },
    emailMeta: {
      required: true,
    },
    openedFrom: {
      required: true,
    },
    openedType: {
      required: false,
    },
    templateType: {
      required: true,
      default: 'template',
    },
    showResetTemplate: {
      required: false,
      default: false,
    },
    allowSaveRows: {
      required: false,
      default: false,
    },
  },

  data() {
    return {
      contentChanged: false,
      saveAs: 1,
      jsonData: '',
      htmlData: '',
      emailTemplateMeta: {},
      restrictedDomains: [],
      blockedDomainsFetched: false,
      isAffiliateSubmitted: false,
      affiliatePromo: null,
      promos: [],
      affiliateLink: null,
      affiliateLinks: [],
      isRowSaveSubmitted: false,
      rowName: '',
      rowData: {},
      showLimitBanner: true,
      bannerConfig: {
        message: this.$t('frontend_groovemail_premium_builder_access_message'),
        size: 'regular',
        color: 'bg-primary-dark',
        textColor: 'text-primary-invert',
        bannerActions: true,
        actionItems: {
          actionBtnType: 'secondary',
          actionBtnText: 'frontend_groovemail_upgrade_btn',
        },
      },
    };
  },

  validations: {
    rowName: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(50),
    },
  },

  components: {
    EmailBuilder,
    TemplateMetaData,
    TemplateFolderCreate,
    VuePerfectScrollbar,
    Treeselect,
    UpgradeContent,
    'gd-banner': GDBanner,
    TemplateAddIcon,
    TemplateUpdateIcon,
    ExitLeftIcon,
    TemplateIcon
},

  computed: {
    promoList() {
      const promoList = [];
      if (this.promos && this.promos.length) {
        this.promos.forEach((element) => {
          promoList.push({ id: element.id, label: element.name });
        });
      }
      return promoList;
    },

    affiliateLinkList() {
      const affiliateLinkList = [];
      if (this.affiliateLinks && this.affiliateLinks.length) {
        this.affiliateLinks.forEach((element) => {
          affiliateLinkList.push({ id: element.id, label: element.name });
        });
      }
      return affiliateLinkList;
    },

    genericUrl() {
      return window.config.apiUrl.substr(
        0,
        window.config.apiUrl.lastIndexOf('/')
      );
    },

    // new plans based limit check
    canUsePremiumBuilder() {
      return auth.fetchFeatureValue('groovemail_can_use_email_builder') === 1;
    },

  },

  async created() {
    if (this.blockedLinkRestriction) {
      await this.fetchBlockedDomain();
    } else {
      this.blockedDomainsFetched = true;
    }
  },

  async mounted() {
    this.updateLimitBanner(true);
  },

  methods: {
    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    openUpgradeModalForFreeUsers() {
      this.$root.$emit('modal-open', 'upgrade-modal-for-limit-builder');
    },

    closeUpgradeModalForFreeUsers() {
      this.$root.$emit('modal-close', 'upgrade-modal-for-limit-builder');
    },

    async fetchBlockedDomain() {
      try {
        this.showLoader();
        const blockedDomains = await axios.get(
          '/get-blocked-domains-and-messages'
        );
        blockedDomains.data.forEach((element) => {
          this.restrictedDomains.push(element.domain);
        });
        this.hideLoader();
        this.blockedDomainsFetched = true;
      } catch (e) {
        this.hideLoader();
      }
    },

    async saveBuilderContent(saveAs) {
      if (this.canUsePremiumBuilder) {
        this.saveAs = saveAs;
        this.$refs['email-builder'].saveEmail();
      } else {
        this.openUpgradeModalForFreeUsers();
      }
    },

    // This function saves the email data as either an email or a template, depending on the value of the saveAs property
    savedAsEmail(jsonData, htmlData) {
      // Define a helper function to handle saving the data as an email or a template
      const saveData = () => {
        // Set the jsonData and htmlData properties to the provided data
        this.jsonData = jsonData;
        this.htmlData = htmlData;

        // If the saveAs property is 1 or 3, save the data as an email
        if (this.saveAs === 1 || this.saveAs === 3) {
          this.savedDataAsEmail();
        }
        // If the saveAs property is 2 or 4, save the data as a template
        else if (this.saveAs === 2 || this.saveAs === 4) {
          this.savedDataAsTemplate(this.saveAs);
        }
      };

      // If the blockedLinkRestriction property is true, check if the email content has blocked links
      if (this.blockedLinkRestriction) {
        const blockedLinksData = this.checkIfContentHasBlockedLinks(jsonData);
        // If the email content does not have blocked links, save the data
        if (!blockedLinksData.hasBlockedLinks) {
          saveData();
        }
        // If the email content has blocked links, show an error message
        else {
          this.showErrorMessage(
            'frontend_groovemail_befree_email_builder_content_has_blocked_links',
            'frontend_groovemail_befree_email_builder_remove_blocked_links',
            blockedLinksData.blockedLinks
          );
        }
      }
      // If the blockedLinkRestriction property is false, save the data
      else {
        saveData();
      }
    },

    async savedDataAsEmail() {
      this.emailTemplateMeta = { ...this.emailMeta };
      if (!this.emailTemplateMeta.emailId) {
        this.openTemplateMetaModal();
      } else {
        const imageUploadUrl = await this.generateTemplateImageUrl();
        this.emailTemplateMeta.screenshot = imageUploadUrl?.link || 'https://assets-test.grooveapps.com/pages-previews/no-screenshot.png';
        this.$emit(
          'saveEmailTemplateContent',
          this.saveAs,
          this.jsonData,
          this.htmlData,
          this.emailTemplateMeta
        );
      }
    },

    async generateTemplateImageUrl() {
      this.showLoader();
      const el = this.$refs['email-builder-html-content'];
      const options = {
        type: 'dataURL',
        useCORS: true,
      };
      
      let imageUploadUrl;
      try {
        const dataurl = await this.$html2canvas(el, options);
  
        const imageBlob = await imageUtils.dataURItoBlob(dataurl);
  
        const screenshotFile = new FormData();
        screenshotFile.append('screenshot', imageBlob);

        imageUploadUrl = await imageUtils.uploadScreenshot(screenshotFile);
      } catch (e) {
        imageUploadUrl = '';
        this.hideLoader();
      }
      
      this.hideLoader();
      return imageUploadUrl;
    },

    async savedDataAsTemplate(saveAs) {
      if (this.templateId) {
        const templateData = await this.fetchTemplateData();
        this.emailTemplateMeta = {
          templateId: templateData.data.id,
          templateName: templateData.data.name,
          templateFolder: templateData.data.category_id,
        };
      } else {
        this.emailTemplateMeta = {
          templateId: null,
          templateName: '',
          templateFolder: null,
        };
      }
      if (saveAs !== 4) {
        this.openTemplateMetaModal();
      } else {
        this.saveContentWithMeta(saveAs);
      }
    },

    async fetchTemplateData() {
      try {
        this.showLoader();
        const currentTemplate = await axios.get(
          `/user/template/${this.templateId}`
        );
        this.hideLoader();
        return currentTemplate;
      } catch (e) {
        this.hideLoader();
        return null;
      }
    },

    checkIfContentHasBlockedLinks(jsonData) {
      let hasBlockedLinks = false;
      const blockedLinks = [];
      this.restrictedDomains.forEach((link) => {
        if (jsonData.includes(link)) {
          hasBlockedLinks = true;
          blockedLinks.push(link);
        }
      });
      return { blockedLinks, hasBlockedLinks };
    },

    async saveContentWithMeta(saveAs) {
      if (saveAs !== 4) {
        this.closeTemplateMetaModal();
      }

      const imageUploadUrl = await this.generateTemplateImageUrl();
      this.emailTemplateMeta.screenshot = imageUploadUrl?.link || 'https://assets-test.grooveapps.com/pages-previews/no-screenshot.png';

      this.$emit(
        'saveEmailTemplateContent',
        this.saveAs,
        this.jsonData,
        this.htmlData,
        this.emailTemplateMeta
      );
    },

    openTemplateMetaModal() {
      this.$root.$emit('modal-open', 'template-meta-data-modal');
    },

    closeTemplateMetaModal() {
      this.$root.$emit('modal-close', 'template-meta-data-modal');
    },

    updatedTemplateMeta(data) {
      this.emailTemplateMeta = data;
    },

    openFolderModal() {
      this.$root.$emit('modal-open', 'template-folder-create-modal');
    },

    closeFolderModal() {
      this.$root.$emit('modal-close', 'template-folder-create-modal');
    },

    closeCreateFolderModal(folderCreated, folderId) {
      this.closeFolderModal();
      this.$refs.templateMetaData.resetTemplateFolder();
      if (folderCreated) {
        this.$refs.templateMetaData.fetchFolders(folderId);
      }
    },

    resetFolderValue() {
      this.$refs.templateMetaData.resetTemplateFolder();
    },

    showErrorMessage(errorMessage, errorMessage2 = '', linkData = []) {
      showAlert({
        iconType: 'alert-error',
        html: `
          <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark"> ${this.$t(errorMessage)}
            <span class="text-sm font-bold text-deep-dark">${linkData.join(', ')}</span>
            <span class="text-sm text-deep-dark"> ${this.$t(errorMessage2)}</span>
          </p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    checkChangeInContent() {
      return this.contentChanged;
    },

    async openAffiliateLinkModal() {
      await this.fetchPromos();
      this.$root.$emit('modal-open', 'affiliate-link-create-modal');
    },

    initializeAffiliateData() {
      this.isAffiliateSubmitted = false;
      this.affiliatePromo = null;
      this.promos = [];
      this.affiliateLink = null;
      this.affiliateLinks = [];
    },

    closeAffiliateLinkModal() {
      this.initializeAffiliateData();
      this.removeAffiliateSelector();
      this.$root.$emit('modal-close', 'affiliate-link-create-modal');
    },

    removeAffiliateSelector() {
      this.$refs['email-builder'].closeAffiliateSelector();
    },

    closedAffiliateLinkModal() {
      this.initializeAffiliateData();
      this.removeAffiliateSelector();
    },

    async fetchPromos() {
      try {
        this.showLoader();
        const promos = await axios.get(`${this.genericUrl}/groovesell/promos`);
        this.promos = promos?.data?.data?.length ? promos.data.data : [];
        this.hideLoader();
      } catch (e) {
        this.hideLoader();
      }
    },

    async updatedAffiliatePromo(promo) {
      this.affiliateLink = null;
      this.affiliateLinks = [];
      try {
        this.showLoader();
        const affLinks = await axios.get(
          `${this.genericUrl}/groovesell/affiliate-links?funnel_id=${promo.id}`
        );
        this.affiliateLinks = affLinks?.data?.length ? affLinks.data : [];
        this.hideLoader();
      } catch (e) {
        this.hideLoader();
      }
    },

    createNewAffiliateLink() {
      this.isAffiliateSubmitted = true;
      if (this.affiliatePromo && this.affiliateLink) {
        const currAffiliate = this.affiliateLinks.find(
          (ele) => ele.id === this.affiliateLink
        );
        this.$refs['email-builder'].insertAffiliateLink(currAffiliate);
        this.$root.$emit('modal-close', 'affiliate-link-create-modal');
        this.initializeAffiliateData();
      }
    },

    openSaveRowMetaModal(rowData) {
      this.rowData = { ...rowData };
      this.rowName = this.rowData.name;
      this.$root.$emit('modal-open', 'row-meta-modal');
    },

    closedRowModal() {
      this.$v.rowName.$reset();
      this.rowName = '';
      this.$refs['email-builder'].closeRowCreation();
    },

    closeRowModal() {
      this.$root.$emit('modal-close', 'row-meta-modal');
      this.closedRowModal();
    },

    createNewRow() {
      this.isRowSaveSubmitted = true;
      this.$v.rowName.$touch();
      if (!this.$v.rowName.$invalid) {
        this.$refs['email-builder'].createNewRow({
          name: this.rowName,
        });
        this.$root.$emit('modal-close', 'row-meta-modal');
        this.$v.rowName.$reset();
        this.rowName = '';
      }
    },

    changeTemplate() {
      if (this.canUsePremiumBuilder) {
        this.$emit('changeCurrentTemplate');
      } else {
        this.openUpgradeModalForFreeUsers();
      }
    },

    async onSaveRow(rowData) {
      try {
        this.showLoader();
        const rowPayload = {
          row_name: rowData.rowName,
          json: rowData.rowJson,
        };
        if (this.rowData.id) {
          await axios.put(`user/row/${this.rowData.id}`, rowPayload);
        } else {
          await axios.post('/user/row/create', rowPayload);
        }
        this.$refs['email-builder'].rowDataCreateUpdate();
        this.rowData = {};
        this.hideLoader();
      } catch (e) {
        this.hideLoader();
      }
    },

    updateLimitBanner(show) {
      this.showLimitBanner = show;
    },

    goToUpgradePage() {
      const user = auth.authenticatedUser();
      const url = window.gdEnv[`UPGRADE_URL_${user?.metadata?.region?.toUpperCase()}`] || window.gdEnv[`UPGRADE_URL`];
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss">
.gm-beefree-preview-content.z-negate {
  z-index: -5;
}
</style>
